import { render } from "./Judges.vue?vue&type=template&id=1b599e22"
import script from "./Judges.vue?vue&type=script&lang=js"
export * from "./Judges.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__